import React from 'react';
import moment from 'moment';
import cn from 'classnames';
import { Typography } from '_atoms/Typography';
import { ReactComponent as FileImage } from 'dist/icons/uploaded_file.svg';
import { ReactComponent as LinkImage } from 'dist/icons/cvs-link.svg';
import type { FileProps } from './types';
import './style.scss';

export const File: React.FC<FileProps> = ({ file, size, className, ...props }) => (
  <a
    className={cn('file-default', size, { link: file.link }, className)}
    href={file.file}
    target="_blank"
    rel="noreferrer noopener"
    {...props}
  >
    {file.link ? <LinkImage className="file-default__icon" /> : <FileImage className="file-default__icon" />}
    <div>
      <Typography.Text className="file-default__title">{file.filename}</Typography.Text>
      <Typography.Caption className="file-default__subtitle">
        {moment(file.uploaded).format('MM/DD/YYYY')}
      </Typography.Caption>
    </div>
  </a>
);
